import { createFileRoute } from '@tanstack/react-router';

import { SectionPlaceholder } from '@/shared/ui/SectionPlaceholder';

export const Route = createFileRoute('/_app/messages')({
  component: () => <SectionPlaceholder title="Сообщения" icon="messages" />,
});
